import { AsyncEvent } from 'ts-events';
export class ThemeService {
    $interval;
    log;
    evtThemeChange = new AsyncEvent();
    _theme = "threema";
    static $inject = ['$interval', 'LogService'];
    constructor($interval, logService) {
        this.$interval = $interval;
        this.log = logService.getLogger('Theme-S', 'color: #fff; background-color: #cc9900');
        this.log.debug(`Initializing with theme ${this.theme}`);
    }
    get theme() {
        return this._theme;
    }
    changeTheme(theme) {
        this._theme = theme;
        this.evtThemeChange.post(theme);
    }
}
